var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.995 27.083H5.845a1.43 1.43 0 0 1-.715-2.666l12.79-7.412 12.791 7.412a1.43 1.43 0 0 1-.716 2.665m1.615-4.216-12.793-7.413v-.552c0-.629.359-1.214.937-1.527a3.837 3.837 0 0 0 2.02-3.542 3.87 3.87 0 0 0-3.704-3.704 3.823 3.823 0 0 0-2.823 1.075 3.824 3.824 0 0 0-1.182 2.778.896.896 0 0 0 1.792 0c0-.566.225-1.094.633-1.487a2.046 2.046 0 0 1 1.512-.575c1.07.04 1.94.91 1.98 1.98.03.794-.384 1.521-1.082 1.9a3.539 3.539 0 0 0-1.876 3.102v.552L4.231 22.866a3.232 3.232 0 0 0-1.606 2.788 3.225 3.225 0 0 0 3.22 3.221h24.15a3.225 3.225 0 0 0 3.22-3.221 3.232 3.232 0 0 0-1.605-2.788",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHanger);
export default __webpack_public_path__ + "static/media/icon_hanger.1d516aa10f3c7c843e59e5c0e42b4ee9.svg";
export { ForwardRef as ReactComponent };